import { Button, Image, Menu, Dropdown, Space } from "antd";
import { Link, useHistory } from 'react-router-dom';
import { CancelIcon, DropdownIcon, ECartIcon } from 'svgIcon';
import MonogramIcon from "assets/images/mongram.jpg";
import { baseImageURL } from 'utils/env';
import { EcommerceFlow, selectedChainIcon } from 'utils/helper';
import CBasketComponent from 'components/Basket/BasketCommon/CBasketComponent';
import { useBasket } from 'containers/POSContainer/constant';

const ECHeaderComponent = ({
    merchantContent,
    chainList,
    showShippingLayout,
    showSideBasket,
    setShowSideBasket,
    setShowShippingLayout,
    ecommerceContent,
    isEndsWithSlash,
    pagesContent
}: any) => {
    const itemlist = useBasket();
    const history = useHistory();

    let length = 0;
    if (itemlist && itemlist.itemList) {
        length = itemlist.itemList.length;
    }

    const getMenu = (chainList: any) => (
        <Menu>
            {chainList.map((item: any) => (
                <Menu.Item key={item.id.toString()} className="chainList">
                    <div>{selectedChainIcon(item.blockchain_name)}</div>
                    <p>{item.blockchain_name}</p>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className="ec-header-wrapper">
            {merchantContent && (
                <Image
                    src={merchantContent.logo_path !== null ? `${baseImageURL}${merchantContent.logo_path}` : MonogramIcon}
                    alt="profile Picture"
                    preview={false}
                />
            )}
            <div className="ec-header-wrapper-right">
                {!isEndsWithSlash && !showShippingLayout && (
                    <>
                        {chainList && chainList.length > 0 && (
                            <Dropdown overlay={getMenu(chainList)} className="dropDown">
                                <div onClick={(e) => e.preventDefault()}>
                                    <Space className="subInnerHeading"> Supported Blockchain <DropdownIcon /></Space>
                                </div>
                            </Dropdown>
                        )}
                        {showSideBasket ? (
                            <div className="cross-icon" onClick={() => setShowSideBasket(false)}> <CancelIcon /></div>
                        ) : (
                            <div className={length > 0 ? "basket-icon active" : "basket-icon"} onClick={() => setShowSideBasket(true)}>
                                <ECartIcon />
                                <span className="ePNum">{length > 0 && length}</span>
                            </div>
                        )}
                    </>
                )}
            </div>
            {showSideBasket && (
                <CBasketComponent
                    flowName={EcommerceFlow}
                    setShowSideBasket={setShowSideBasket}
                    showSideBasket={showSideBasket}
                    setShowShippingLayout={setShowShippingLayout}
                />
            )}
        </div>
    );
};

export default ECHeaderComponent;